import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { AuthActions } from '@app/store/actions';
import * as fromRoot from '@app/store/reducers';
import { TranslocoPipe } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'am-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  imports: [MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, RouterLink, AsyncPipe, TranslocoPipe],
  standalone: true,
})
export class UserMenuComponent implements OnInit {
  username$: Observable<string>;
  userIsAdmin$: Observable<boolean>;

  private readonly _store = inject<Store<fromRoot.State>>(Store);

  ngOnInit(): void {
    this.userIsAdmin$ = this._store.select(fromRoot.getCurrentUserIsAdmin);
    this.username$ = this._store.select(fromRoot.getCurrentUserUsername);
  }

  logout(): void {
    this._store.dispatch(AuthActions.logoutUser());
  }
}
